"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require("react-addons-css-transition-group");

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _ListItem = require("./ListItem");

var _ListItem2 = _interopRequireDefault(_ListItem);

var _Util = require("../Util/Util");

var _Util2 = _interopRequireDefault(_Util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    (0, _classCallCheck3.default)(this, List);
    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
  }

  (0, _createClass3.default)(List, [{
    key: "getListItems",
    value: function getListItems(list) {
      var _this2 = this;

      var childIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var props = this.props;

      var items = list.map(function (item, parentIndex) {
        var key = parentIndex + "." + childIndex;
        childIndex++;

        if (_Util2.default.isArrayLike(item.content)) {
          return _react2.default.createElement(
            _ListItem2.default,
            (0, _extends3.default)({}, _Util2.default.exclude(item, ["content"]), {
              key: key,
              tag: item.tag,
              transition: true,
              transitionName: props.transitionName,
              transitionEnterTimeout: props.transitionEnterTimeout,
              transitionLeaveTimeout: props.transitionLeaveTimeout
            }),
            _this2.getListItems(item.content, childIndex)
          );
        } else {
          return _react2.default.createElement(
            _ListItem2.default,
            (0, _extends3.default)({ key: key }, _Util2.default.exclude(item, ["content"])),
            item.content
          );
        }
      });

      return items;
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;

      var Tag = props.tag;

      // Uses all passed properties as attributes, excluding propTypes
      var attributes = _Util2.default.exclude(props, (0, _keys2.default)(List.propTypes));

      if (props.transition) {
        return _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          (0, _extends3.default)({}, attributes, {
            className: props.className,
            component: Tag,
            transitionName: props.transitionName,
            transitionEnterTimeout: props.transitionEnterTimeout,
            transitionLeaveTimeout: props.transitionLeaveTimeout
          }),
          this.getListItems(props.content)
        );
      }

      return _react2.default.createElement(
        Tag,
        (0, _extends3.default)({}, attributes, { className: props.className }),
        this.getListItems(props.content)
      );
    }
  }]);
  return List;
}(_react2.default.Component);

List.defaultProps = {
  className: "list",
  tag: "ul",
  transition: true,
  transitionName: "list-item",
  transitionEnterTimeout: 500,
  transitionLeaveTimeout: 500
};

List.propTypes = {
  className: _react.PropTypes.string,
  // List of items in the list
  content: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(
  // Each item in the array should be an object
  _react.PropTypes.shape({
    // Optionally add a class to a given item
    className: _react.PropTypes.string,
    // An item can be a container of another ist
    items: _react.PropTypes.array,
    // Optional tag for item instead of an `li`
    tag: _react.PropTypes.string,
    // If this item isn't a list of other items just use a value
    value: _react.PropTypes.string
  })), _react.PropTypes.string]).isRequired,
  // Optional tag for the container of the list
  tag: _react.PropTypes.string,
  transition: _react.PropTypes.bool,
  transitionName: _react.PropTypes.string,
  // Transition lengths
  transitionEnterTimeout: _react2.default.PropTypes.number,
  transitionLeaveTimeout: _react2.default.PropTypes.number
};

module.exports = List;


//////////////////
// WEBPACK FOOTER
// ./~/reactjs-components/lib/List/List.js
// module id = 1310
// module chunks = 2